import { api } from './api';

export interface EmailQueueStatistics {
  pending: number;
  processing: number;
  sent: number;
  failed: number;
  cancelled: number;
  total: number;
}

export interface EmailQueueItem {
  id: string;
  customerId: string | null;
  to: string;
  subject: string;
  body: string;
  isHtml: boolean;
  status: string;
  origin: string | null;
  attemptCount: number;
  maxAttempts: number;
  errorMessage: string | null;
  errorStackTrace: string | null;
  hangfireJobId: string | null;
  sentAt: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy: string | null;
}

export interface PagedEmailQueueResult {
  items: EmailQueueItem[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface EmailQueueFilter {
  status?: string;
  origin?: string;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  pageSize?: number;
}

export const EMAIL_STATUS_LABELS: Record<string, string> = {
  Pending: 'Pendente',
  Processing: 'Processando',
  Sent: 'Enviado',
  Failed: 'Falhou',
  Cancelled: 'Cancelado',
};

class EmailQueueService {
  async getStatistics(): Promise<EmailQueueStatistics> {
    const response = await api.get<EmailQueueStatistics>('/email-queue/statistics');
    return response.data;
  }

  async getEmails(params: EmailQueueFilter): Promise<PagedEmailQueueResult> {
    const response = await api.get<PagedEmailQueueResult>('/email-queue', { params });
    return response.data;
  }

  async getById(id: string): Promise<EmailQueueItem> {
    const response = await api.get<EmailQueueItem>(`/email-queue/${id}`);
    return response.data;
  }

  async resend(id: string): Promise<void> {
    await api.post(`/email-queue/${id}/resend`);
  }

  async cancel(id: string): Promise<void> {
    await api.delete(`/email-queue/${id}`);
  }

  async cancelMany(ids: string[]): Promise<{ cancelled: number }> {
    const response = await api.delete<{ cancelled: number }>('/email-queue/batch', { data: ids });
    return response.data;
  }
}

export const emailQueueService = new EmailQueueService();
